/**
 * HEVI.HU – Košík, Variant B ("HU-prototypický")
 * ------------------------------------------------------------
 * Injektovateľný skript pre Conversion.io (Variation JS).
 * Cieľ: zvýšiť cart → checkout na hevi.hu bez zmeny témy.
 *
 * Téma: Shopify "Combine" 2.4 (kópia SK témy). Overené selektory (30. 9. 2026):
 *   #AjaxCartSubtotal            – pravý stĺpec, re-renderuje sa cez AJAX
 *   .cart__details               – widget so súčtom
 *   .cart__total                 – riadok "Összeg"
 *   .cart__shipping              – text "Az ár tartalmazza az ÁFÁ-t"
 *   #CheckOut / button[name=checkout] .button__text  – tlačidlo "Fizetés"
 *   .cart-holder[data-items]     – počet položiek (0 = prázdny košík)
 *   cart-form  → event "cart-updated" po každej zmene košíka
 *
 * Čo robí:
 *   1. premenuje tlačidlo "Fizetés" → "Tovább a pénztárhoz" (aj v cart draweri)
 *   2. nad súčet pridá riadok pôvodnej ceny + "Tesztelői kedvezmény −X Ft (−50 %)"
 *   3. progress bar dopravy zdarma (12 900 Ft) + očakávaný dátum doručenia
 *   4. pod tlačidlo: logá platieb, logá dopravy, 30 dní vrátenie, HU podpora, počet hodnotení
 *   5. pošle event do dataLayer + Conversion.io goal pri kliku na checkout
 *
 * Idempotentné – dá sa spustiť opakovane, re-aplikuje sa po každom cart-updated.
 */
(function () {
  'use strict';

  /* ======================= KONFIGURÁCIA ======================= */
  var CFG = {
    // 'discount'   = zľava je reálny discount code (odporúčané; číta cart.total_discount)
    // 'compare_at' = zľava je iba compare-at cena (súčasný stav; dopočíta z /products/{handle}.js)
    PRICING_MODE: 'compare_at',
    DISCOUNT_LABEL: 'Tesztelői kedvezmény',
    DISCOUNT_PCT_BADGE: 'auto',               // percento sa počíta zo skutočnej zľavy v košíku; prázdny string = nezobrazovať badge

    FREE_SHIPPING_THRESHOLD: 12900,           // Ft
    SHIPPING_CUTOFF_HOUR: 12,                 // objednávky do 12:00 → +1 pracovný deň
    DELIVERY_DAYS_BEFORE_CUTOFF: 1,
    DELIVERY_DAYS_AFTER_CUTOFF: 2,
    HU_HOLIDAYS: ['2026-10-23', '2026-11-01', '2026-12-24', '2026-12-25', '2026-12-26',
                  '2027-01-01', '2027-03-15', '2027-03-29', '2027-05-01', '2027-05-17',
                  '2027-08-20', '2027-10-23', '2027-11-01', '2027-12-25', '2027-12-26'],

    PAYMENTS: [                                // poradie = poradie zobrazenia
      { key: 'cod',    label: 'Utánvét',      show: true },
      { key: 'card',   label: 'Bankkártya',   show: true },
      { key: 'apple',  label: 'Apple Pay',    show: false },   // zapni, keď je reálne aktívne
      { key: 'google', label: 'Google Pay',   show: false },
      { key: 'simple', label: 'SimplePay',    show: false },   // zapni po integrácii
      { key: 'barion', label: 'Barion',       show: false }
    ],
    CARRIERS: [
      { key: 'gls-point', label: 'GLS csomagpont',   show: true },
      { key: 'gls-home',  label: 'GLS házhozszállítás', show: true },
      { key: 'foxpost',   label: 'FOXPOST automata', show: false }, // zapni po integrácii
      { key: 'packeta',   label: 'Packeta Z-Pont',   show: false }
    ],

    REVIEWS_COUNT: 0,                          // DOPLŇ reálne číslo (0 = riadok sa nezobrazí)
    REVIEWS_AVG: '4,8',
    SUPPORT_PHONE: '+36 21 212 2046',
    SUPPORT_HOURS: 'H–P 9:00–17:00',
    RETURN_DAYS: 30,

    DRAWER_MODE: 'compact',                    // 'compact' = zľava + 1 riadok doprava/doručenie v cart draweri, 'off' = v draweri len premenované tlačidlo
    BUTTON_LABEL: 'Tovább a pénztárhoz',
    DATALAYER_EVENT: 'hvb_cart_variant_b',
    CONVERSION_GOAL: 'cart_checkout_click'     // názov goalu v Conversion.io
  };

  /* ======================= POMOCNÉ FUNKCIE ======================= */
  var fmt = new Intl.NumberFormat('hu-HU', { style: 'currency', currency: 'HUF', maximumFractionDigits: 0 });
  function ft(minor) { return fmt.format(Math.round(minor / 100)); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var HU_DAYS = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];
  var HU_MONTHS = ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember', 'október', 'november', 'december'];

  function budapestNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Budapest', hour12: false,
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' }).formatToParts(new Date());
    var o = {}; parts.forEach(function (p) { o[p.type] = p.value; });
    return { y: +o.year, m: +o.month, d: +o.day, h: +o.hour % 24 };
  }
  function isoDate(dt) { return dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0'); }
  function isBusinessDay(dt) { var wd = dt.getDay(); return wd !== 0 && wd !== 6 && CFG.HU_HOLIDAYS.indexOf(isoDate(dt)) === -1; }

  function deliveryDate() {
    var n = budapestNow();
    var dt = new Date(n.y, n.m - 1, n.d);
    var days = n.h < CFG.SHIPPING_CUTOFF_HOUR ? CFG.DELIVERY_DAYS_BEFORE_CUTOFF : CFG.DELIVERY_DAYS_AFTER_CUTOFF;
    if (!isBusinessDay(dt)) days = CFG.DELIVERY_DAYS_BEFORE_CUTOFF;          // víkend/sviatok → expedícia najbližší prac. deň
    while (days > 0) { dt.setDate(dt.getDate() + 1); if (isBusinessDay(dt)) days--; }
    return HU_MONTHS[dt.getMonth()] + ' ' + dt.getDate() + '., ' + HU_DAYS[dt.getDay()];
  }

  /* ======================= DÁTA KOŠÍKA ======================= */
  var productCache = {};
  function fetchJSON(url, retry) {
    return fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) {
      if (!r.ok) throw new Error('HTTP ' + r.status);
      return r.json();
    }).catch(function (e) {
      if (retry === undefined) retry = 1;
      if (retry > 0) return new Promise(function (res) { setTimeout(res, 700); }).then(function () { return fetchJSON(url, retry - 1); });
      throw e;
    });
  }

  function compareAtTotal(cart) {
    // vráti Promise<minor units> súčtu compare_at cien položiek (fallback, keď zľava nie je discount code)
    var handles = {};
    cart.items.forEach(function (it) { handles[it.handle] = true; });
    return Promise.all(Object.keys(handles).map(function (h) {
      if (productCache[h]) return productCache[h];
      return (productCache[h] = fetchJSON('/products/' + h + '.js').catch(function () { delete productCache[h]; return null; }));
    })).then(function (products) {
      var byVariant = {};
      products.forEach(function (p) { if (p && p.variants) p.variants.forEach(function (v) { byVariant[v.id] = v; }); });
      var total = 0;
      cart.items.forEach(function (it) {
        var v = byVariant[it.variant_id];
        var cmp = v && v.compare_at_price && v.compare_at_price > it.final_price ? v.compare_at_price : it.final_price;
        total += cmp * it.quantity;
      });
      return total;
    });
  }

  function pricing(cart) {
    if (CFG.PRICING_MODE === 'discount') {
      return Promise.resolve({ original: cart.original_total_price, discount: cart.total_discount, total: cart.total_price });
    }
    return compareAtTotal(cart).then(function (orig) {
      return { original: orig, discount: Math.max(0, orig - cart.total_price), total: cart.total_price };
    });
  }

  /* ======================= CSS ======================= */
  var CSS = '\
.hvb-box{margin:0 0 12px}\
.hvb-row{display:flex;justify-content:space-between;align-items:baseline;gap:12px;font-size:.95em;padding:4px 0}\
.hvb-row--orig{opacity:.65}.hvb-row--orig s{text-decoration:line-through}\
.hvb-row--disc{color:#c62828;font-weight:600}\
.hvb-badge{display:inline-block;background:#c62828;color:#fff;font-weight:700;font-size:.8em;border-radius:4px;padding:2px 7px;margin-left:8px;vertical-align:middle}\
.hvb-ship{margin:10px 0 4px;font-size:.9em}\
.hvb-ship__bar{height:6px;border-radius:6px;background:rgba(0,0,0,.08);overflow:hidden;margin:6px 0}\
.hvb-ship__fill{height:100%;background:#2e7d32;border-radius:6px;transition:width .3s}\
.hvb-ship--free{color:#2e7d32;font-weight:600}\
.hvb-deliv{font-size:.9em;margin:4px 0 12px;display:flex;gap:8px;align-items:center}\
.hvb-deliv b{color:#2e7d32}\
.hvb-trust{margin-top:14px;padding-top:12px;border-top:1px solid rgba(0,0,0,.08);font-size:.85em}\
.hvb-trust__title{font-size:.8em;text-transform:uppercase;letter-spacing:.04em;opacity:.6;margin:8px 0 6px}\
.hvb-pills{display:flex;flex-wrap:wrap;gap:6px}\
.hvb-pill{border:1px solid rgba(0,0,0,.15);border-radius:6px;padding:4px 9px;font-weight:600;background:#fff;color:#111;white-space:nowrap;line-height:1.3}\
.hvb-pill--cod{border-color:#2e7d32;color:#2e7d32}\
.hvb-list{list-style:none;margin:10px 0 0;padding:0}\
.hvb-list li{display:flex;gap:8px;align-items:flex-start;margin:6px 0}\
.hvb-list svg,.hvb-ship svg,.hvb-deliv svg{flex:0 0 16px;width:16px;height:16px;margin-top:2px;vertical-align:-3px}\
.hvb-list a{color:inherit;text-decoration:underline}\
.cart--empty .hvb-box,.cart--empty .hvb-trust{display:none}\
@media screen and (max-width:1023px){.cart__subtotal-widget{position:static!important}}\
#site-cart-sidebar .hvb-row,#site-cart-sidebar .hvb-ship,#site-cart-sidebar .hvb-deliv{font-size:.85em;padding:2px 0;margin:2px 0}\
.hvb-trust--drawer{margin:0 0 var(--sidebar-gutter,24px);padding-top:16px;padding-bottom:16px;border-top:1px solid rgba(0,0,0,.08);border-bottom:1px solid rgba(0,0,0,.08)}\
';

  function injectCSS() {
    if (document.getElementById('hvb-css')) return;
    var s = el('style'); s.id = 'hvb-css'; s.textContent = CSS; document.head.appendChild(s);
  }

  /* ======================= RENDER ======================= */
  var CHECK = '<svg viewBox="0 0 16 16" fill="none" stroke="#2e7d32" stroke-width="2"><path d="M3 8.5l3 3 7-7"/></svg>';

  function renderPricing(details, p, compact) {
    var box = details.querySelector('.hvb-box') || el('div', 'hvb-box');
    box.innerHTML = '';
    if (p.discount > 0) {
      if (!compact) box.appendChild(el('div', 'hvb-row hvb-row--orig', '<span>Eredeti ár</span><s>' + ft(p.original) + '</s>'));
      box.appendChild(el('div', 'hvb-row hvb-row--disc',
        '<span>' + esc(CFG.DISCOUNT_LABEL) + (CFG.DISCOUNT_PCT_BADGE && p.original > 0 ? '<span class="hvb-badge">−' + Math.round(p.discount / p.original * 100) + ' %</span>' : '') + '</span><span>−' + ft(p.discount) + '</span>'));
    }
    var total = details.querySelector('.cart__total');
    if (total && box.parentNode !== details) details.insertBefore(box, total);
  }

  function renderShipping(details, cart, compact) {
    var ship = details.querySelector('.hvb-ship') || el('div', 'hvb-ship');
    var deliv = details.querySelector('.hvb-deliv') || el('div', 'hvb-deliv');
    var thresholdMinor = CFG.FREE_SHIPPING_THRESHOLD * 100;
    var pct = Math.min(100, Math.round(cart.total_price / thresholdMinor * 100));
    if (cart.total_price >= thresholdMinor) {
      ship.className = 'hvb-ship hvb-ship--free';
      ship.innerHTML = CHECK + ' Ingyenes szállítás – a rendelésed elérte a ' + esc(fmt.format(CFG.FREE_SHIPPING_THRESHOLD)) + '-ot';
    } else {
      ship.className = 'hvb-ship';
      ship.innerHTML = 'Még <b>' + ft(thresholdMinor - cart.total_price) + '</b> az ingyenes szállításig' +
        (compact ? '' : '<div class="hvb-ship__bar"><div class="hvb-ship__fill" style="width:' + pct + '%"></div></div>');
    }
    deliv.innerHTML = CHECK + '<span>Várható kézbesítés: <b>' + deliveryDate() + '</b> <span style="opacity:.6">(12:00-ig leadott rendelés esetén másnap)</span></span>';
    if (compact) {
      ship.innerHTML = CHECK + ' ' + (cart.total_price >= thresholdMinor ? 'Ingyenes szállítás' : 'Még ' + ft(thresholdMinor - cart.total_price) + ' az ingyenes szállításig') +
        ' · Kézbesítés: <b>' + deliveryDate() + '</b>';
      deliv.remove();
    }

    var vat = details.querySelector('.cart__shipping');
    var anchor = vat || details.querySelector('.cart__total');
    if (anchor) { anchor.insertAdjacentElement('afterend', ship); if (!compact) ship.insertAdjacentElement('afterend', deliv); }
  }

  function pills(list) {
    return '<div class="hvb-pills">' + list.filter(function (x) { return x.show; })
      .map(function (x) { return '<span class="hvb-pill hvb-pill--' + x.key + '">' + esc(x.label) + '</span>'; }).join('') + '</div>';
  }

  function renderTrust(details, host) {
    host = host || details;
    var t = host.querySelector(':scope > .hvb-trust') || el('div', 'hvb-trust' + (host === details ? '' : ' hvb-trust--drawer sidebar-large-padding hide-if-empty-cart'));
    var reviews = CFG.REVIEWS_COUNT > 0
      ? '<li>' + CHECK + '<span><b>' + esc(CFG.REVIEWS_AVG) + '/5</b> – ' + CFG.REVIEWS_COUNT.toLocaleString('hu-HU') + ' vásárlói értékelés</span></li>' : '';
    t.innerHTML =
      '<div class="hvb-trust__title">Fizetési módok</div>' + pills(CFG.PAYMENTS) +
      '<div class="hvb-trust__title">Szállítás</div>' + pills(CFG.CARRIERS) +
      '<ul class="hvb-list">' +
        '<li>' + CHECK + '<span><b>' + CFG.RETURN_DAYS + ' napos ingyenes visszaküldés</b> – ha nem válik be, visszaküldöd, mi álljuk a postaköltséget</span></li>' +
        '<li>' + CHECK + '<span>Magyar ügyfélszolgálat: <a href="tel:' + esc(CFG.SUPPORT_PHONE.replace(/\s/g, '')) + '">' + esc(CFG.SUPPORT_PHONE) + '</a> (' + esc(CFG.SUPPORT_HOURS) + ')</span></li>' +
        reviews +
      '</ul>';
    if (host === details) host.appendChild(t);
    else {                                              // drawer: hneď pod položky košíka, pred cross-sell
      var after = host.querySelector(':scope > .cart-form');
      if (after && after.nextSibling !== t) after.insertAdjacentElement('afterend', t); else if (!after) host.appendChild(t);
    }
  }

  function renameButtons() {
    document.querySelectorAll('button[name="checkout"] .button__text, #CheckOut .button__text').forEach(function (s) {
      if (s.textContent.trim() !== CFG.BUTTON_LABEL) s.textContent = CFG.BUTTON_LABEL;
    });
  }

  function bindTracking() {
    document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
      if (b.dataset.hvbBound) return;
      b.dataset.hvbBound = '1';
      b.addEventListener('click', function () {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: CFG.DATALAYER_EVENT + '_checkout_click' });
        try { if (window.convert && convert.triggerConversion) convert.triggerConversion(CFG.CONVERSION_GOAL); } catch (e) {}
      });
    });
  }

  /* ======================= HLAVNÝ BEH ======================= */
  var running = false;
  function apply() {
    if (running) return; running = true;
    injectCSS();
    renameButtons();
    bindTracking();
    var all = document.querySelectorAll('.cart__details');
    if (!all.length) { running = false; return; }
    fetchJSON('/cart.js').then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) { running = false; return; }
      return pricing(cart).then(function (p) {
        all.forEach(function (details) {
          var inDrawer = !!details.closest('#site-cart-sidebar, .sidebar__footer');
          if (inDrawer && CFG.DRAWER_MODE === 'off') { details.dataset.hvbApplied = '1'; return; }
          renderPricing(details, p, inDrawer);
          renderShipping(details, cart, inDrawer);
          if (!inDrawer) renderTrust(details);        // /cart: trust blok priamo vo widgete
          else {                                       // drawer: footer je sticky → trust blok do scrollovacieho tela
            var body = document.querySelector('#site-cart-sidebar .sidebar__body');
            if (body) renderTrust(details, body);
          }
          details.dataset.hvbApplied = '1';
        });
      });
    }).catch(function () {}).then(function () { running = false; });
  }

  function init() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event: CFG.DATALAYER_EVENT });
    apply();
    var cf = document.querySelector('cart-form');
    if (cf) cf.addEventListener('cart-updated', function () { setTimeout(apply, 50); });
    document.addEventListener('cart-updated', function () { setTimeout(apply, 50); });
    var target = document.body;
    var pending;
    new MutationObserver(function () {
      var d = document.querySelector('.cart__details:not([data-hvb-applied])');
      if (d) { clearTimeout(pending); pending = setTimeout(apply, 80); }
      renameButtons();
    }).observe(target, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
